import ScrollableColumn from "./ScrollableColumn";

export default ScrollableColumn;
